module.exports = __webpack_public_path__ + "static/media/copy-icon.a953c338.svg";